(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.Qd.FormsViewer.Constants = factory();
    }
}(typeof self !== 'undefined' ? self : this, function () {
    "use strict";
    return {
        MenuClass: ".fv-menu",
        MenuHolderClass: ".fv-menu-holder",
        MenuWidgetClass: ".fv-menu-widget",
        AccessTypes: {
            Template: "template",
            Library: "library",
            TemplateName: "templateName"
        }
    };
}));
